import React, { Component, Fragment } from 'react';
import { Field } from 'formik';

import CheckboxesField from 'buyside/components/presentation/Form/Field/CheckboxesField/checkboxesField';
const {
  assetClassNames,
  sectorNames,
  geographyNames
} = require('buyside/util/constantsFromRails.json');

import styles from './InvestmentMandateStyles';

class InvestmentMandate extends Component {
  generateMandate(employer) {
    const namespace = employer ? 'companyInvestmentMandate' : 'positionInvestmentMandate';
    return [
      {
        label: 'Asset Class',
        options: assetClassNames,
        name: `${namespace}.assets`
      },
      {
        label: 'Sector',
        options: sectorNames,
        name: `${namespace}.sectors`
      },
      {
        label: 'Region',
        options: geographyNames,
        name: `${namespace}.regions`
      }
    ];
  }

  renderCheckbox({ name, options }) {
    const { isMobile } = this.props;

    return (
      <div key={name} className={styles.section}>
        <Field
          component={CheckboxesField}
          name={name}
          options={options}
          numColumns={isMobile ? 2 : 3}
        />
      </div>
    );
  }

  render() {
    const { employer } = this.props;
    const mandate = this.generateMandate(employer);

    return (
      <div>
        {mandate.map(({ label, options, name }) => (
          <Fragment key={label}>
            <div className={styles.label}>{label}</div>
            {this.renderCheckbox({ name, options })}
          </Fragment>
        ))}
      </div>
    );
  }
}

export default InvestmentMandate;
